export default __webpack_public_path__ + "static/media/Sec2Mobile.89deb483.png";